import React from "react";
import { Alert } from "reactstrap";
import { Trans } from "react-i18next";
import { get } from "lodash";
import { Link } from "react-router-dom";

export const withXeroErrors = () => (BaseComponent) =>
  class XeroErrors extends React.Component {
    state = {};

    setXeroErrors = (xeroErrors) => {
      if (xeroErrors && xeroErrors.response) {
        const status = get(xeroErrors, "response.status");
        if (!(status >= 400 && status < 500)) throw xeroErrors;
      }
      this.setState({ xeroErrors });
    };

    renderXeroErrors = (props) => {
      const { xeroErrors } = this.state;

      if (xeroErrors && xeroErrors.response) {
        const code = get(xeroErrors, "response.data.code");
        const detail = get(xeroErrors, "response.data.detail");

        let error = null;

        if (code === "XeroNotConnected") {
          error = (
            <Trans>
              <span className="fa fa-exclamation-circle" /> The selected
              organisation is not connected to Xero, please use the{" "}
              <Link to="/organisations">Manage Organisations</Link> page to
              connect.
            </Trans>
          );
        } else if (code === "XeroUnauthorized") {
          error = (
            <Trans>
              <span className="fa fa-exclamation-circle" /> Xero details are not
              valid, please try connecting again from the{" "}
              <Link to="/organisations">Manage Organisations</Link> page.
            </Trans>
          );
        } else if (code === "AccountSuspended") {
          error = (
            <Trans>
              <span className="fa fa-exclamation-circle" /> Your account has
              been suspended, please go to the{" "}
              <Link to="/subscription">Subscription</Link> page for more
              details.
            </Trans>
          );
        } else if (code === "ValidationError") {
          if (!detail && detail.length) throw xeroErrors;

          error = detail.map((i) => (
            <ul className="mb-0 pl-3" key={i}>
              <li key={i}>
                <Trans>{i}</Trans>
              </li>
            </ul>
          ));
        } else {
          error = (
            <Trans>
              <span className="fa fa-exclamation-circle" /> An unknown error
              occurred while processing your request
            </Trans>
          );
        }

        return error ? (
          <Alert color="danger" {...props}>
            {error}
          </Alert>
        ) : null;
      } else if (xeroErrors && xeroErrors.length) {
        return (
          <Alert color="danger" {...props}>
            {xeroErrors.map((i, idx) => (
              <ul className="mb-0 pl-3" key={idx}>
                <li key={idx}>
                  <Trans>{i}</Trans>
                </li>
              </ul>
            ))}
          </Alert>
        );
      } else {
        return null;
      }
    };

    render = () => (
      <BaseComponent
        {...this.props}
        setXeroErrors={this.setXeroErrors}
        XeroErrors={this.renderXeroErrors}
        xeroErrorDetail={this.state.xeroErrors}
      />
    );
  };

export default withXeroErrors;
